import React from 'react'
import * as Sentry from "@sentry/react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            eventId: '',
            errorInfo: '',
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.log({ error, errorInfo });
        Sentry.withScope((scope) => {
            scope.setExtras(errorInfo);
            const eventId = Sentry.captureException(error);
            this.setState({ eventId, errorInfo });
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="card my-5">
                    <div className="card-header">
                        <p>
                            Something went wrong.{' '}
                            <span
                                style={{ cursor: 'pointer', color: '#0077FF' }}
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                Reload this page
                            </span>{' '}
                        </p>
                    </div>
                    <div className="card-body">
                        <details className="error-details">
                            <summary>Click for error details</summary>
                            {this.state.errorInfo && this.state.errorInfo.componentStack.toString()}
                        </details>
                    </div>
                    <button
                        className="bg-primary text-light"
                        onClick={() =>
                            Sentry.showReportDialog({ eventId: this.state.eventId })
                        }
                    >
                        Report feedback
                    </button>
                </div>
            );

        }

        return this.props.children;
    }
}